import React from 'react';
import './keyWords.css'
import {Link} from "react-router-dom";

function KeyWords({keywords = []}) {
    return (
        <div className={'keywords'}>
            <div className={'p-4'}>
                <p>کلمات کلیدی</p>
                <hr/>
                {keywords.map((keyword, index) => (
                    keyword !== "" && <Link key={index} to={'#'}>{keyword}</Link>
                ))}
            </div>
        </div>
    );
}

export default KeyWords;